import { AvailabilityTypes } from '@/modules/caa/domain/models/AvailabilityTypes'
import { CAATypes } from '@/modules/caa/domain/models/CAATypes'
import { useListCAAForManagersQuery } from '@/ui/hooks/queries/useListCAAForManagersQuery'
import { useListCAAForOperationalQuery } from '@/ui/hooks/queries/useListCAAForOperationalQuery'

export const useListCAADailyRecords = ({
  isManager,
  date,
  patientId,
  personaName,
  availability,
  typeCAA
}: {
  isManager: boolean
  date: string
  patientId?: string
  personaName?: string
  availability?: AvailabilityTypes
  typeCAA?: CAATypes
}) => {
  const managerData = useListCAAForManagersQuery({
    date,
    patientId,
    personaName,
    availability,
    typeCAA,
    enabled: isManager
  })

  const operationalData = useListCAAForOperationalQuery({
    date,
    patientId,
    personaName,
    availability,
    typeCAA,
    enabled: !isManager
  })

  return isManager ? managerData : operationalData
}
